/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'
import React from 'react'

interface CloseButtonProps {
  onClick: () => void
}

const CloseButtonContainer = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  svg {
    width: 24px;
    height: 25px;
  }
`

/**
 * Close button component for the onboarding wizard modal
 * Uses the provided SVG icon and handles modal close action
 */
const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => {
  console.log('🔄 CloseButton: Rendering close button')

  return (
    <CloseButtonContainer onClick={onClick} aria-label='Close modal'>
      <svg
        width='24'
        height='25'
        viewBox='0 0 24 25'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M18.2997 6.18214C17.9097 5.79214 17.2797 5.79214 16.8897 6.18214L11.9997 11.0621L7.10973 6.17214C6.71973 5.78214 6.08973 5.78214 5.69973 6.17214C5.30973 6.56214 5.30973 7.19214 5.69973 7.58214L10.5897 12.4721L5.69973 17.3621C5.30973 17.7521 5.30973 18.3821 5.69973 18.7721C6.08973 19.1621 6.71973 19.1621 7.10973 18.7721L11.9997 13.8821L16.8897 18.7721C17.2797 19.1621 17.9097 19.1621 18.2997 18.7721C18.6897 18.3821 18.6897 17.7521 18.2997 17.3621L13.4097 12.4721L18.2997 7.58214C18.6797 7.20214 18.6797 6.56214 18.2997 6.18214Z'
          fill='#797B7E'
        />
      </svg>
    </CloseButtonContainer>
  )
}

export default CloseButton
